import { render, staticRenderFns } from "./BomEdit.vue?vue&type=template&id=401dc4c2&scoped=true"
import script from "./BomEdit.vue?vue&type=script&lang=js"
export * from "./BomEdit.vue?vue&type=script&lang=js"
import style0 from "./BomEdit.vue?vue&type=style&index=0&id=401dc4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401dc4c2",
  null
  
)

export default component.exports